<router-outlet></router-outlet>

<napa-version-renderer></napa-version-renderer>
